export const INFO_ALARM_EXPIRED_TIME = 60 * 60 * 24;
export const SPIN_WHEEL_EXPIRED_TIME = 60 * 60 * 24;
